<template>
	<div class="store-freight-body">
		<div class="fx-title">
			<p>店铺运费</p>
		</div>
		<div class="freight-template-setting">
			<p><span>*</span>运费模板：</p>
			<div class="freight-template-box">
				<el-select v-model="value" class="template-select" size="mini" @change="templateChange">
					<el-option
					v-for="item in options"
					:key="item.ft_id"
					:label="item.ft_name"
					:value="item.ft_id">
					</el-option>
				</el-select>
				<div class="template-item">
					<span class="item-name">起订金额：</span> {{money}} 元
				</div>
				<div class="template-item">
					<span class="item-name">配送方式：</span> {{deliveryWay === 0 ? '快递' : '快递/自提'}}
				</div>
				<div class="template-item">
					<span class="item-name">{{freightWay === 0 ? '按公里' : '按重量'}}：</span>
					<div class="freight-way-box">
						<div class="freight-way">
							<span>每</span> <el-input v-model="startValue" size="mini" :disabled="true" class="template-start-input"/> {{freightWay === 0 ? 'KM' : 'KG'}}， 起送运费 <el-input v-model="startMoney" size="mini" :disabled="true" class="template-freight-input"/> 元
						</div>
						<div class="freight-way">
							<span>每超</span> <el-input v-model="moreValue" size="mini" :disabled="true" class="template-start-input"/> {{freightWay === 0 ? 'KM' : 'KG'}}， 起送运费 <el-input v-model="moreMoney" size="mini" :disabled="true" class="template-freight-input"/> 元
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="freight-btn-box">
			<el-button plain type="primary" size="small" class="btn" @click="cancel">取消</el-button>
			<el-button type="primary" size="small" class="btn" @click="apply">应用</el-button>
		</div>
	</div>
</template>

<script>
export default {
	name: 'storeFreight',
	data () {
		return {
			options: [],
			value: '',
			money: '',
			deliveryWay: 0,
			freightWay: 0,
			startValue: 0,
			startMoney: 0.00,
			moreValue: 0,
			moreMoney: 0.00,
			templateId: '',
			sessionStoreId: ''
		}
	},
	created () {
		this.sessionStoreId = sessionStorage.getItem('storeid')
		this.listPost()
	},
	methods: {
		listPost () {
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/freightTemplate/name/list`
			}).then(res => {
				if (res.result) {
					this.options = res.data.freightTemplates
					this.detailPost('0')
				}
			})
		},
		templateChange (value) {
			this.templateId = value
			this.detailPost(value)
		},
		detailPost (value) {
			let params = {
				freightTemplateid: value,
				shopid: this.sessionStoreId
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/freightTemplate/detail`,
				data: params
			}).then(res => {
				if (res.result) {
					let data = res.data.freightTemplateDetail
					this.money = data.ft_sendamount
					this.deliveryWay = data.ft_selfpickflag
					this.freightWay = data.ft_freighttype
					this.startValue = data.ft_freight
					this.startMoney = data.ft_freightamount
					this.moreValue = data.ft_freightstep
					this.moreMoney = data.ft_freightstepamount
					this.templateId = data.ft_id
					this.value = data.ft_name
				}
			})
		},
		apply () {
			let params = {
				freightTemplateid: this.templateId,
				shopid: this.sessionStoreId
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/freightTemplate/bindshop`,
				data: params
			}).then(res => {
				if (res.result) {
					this.$message.success('模板应用成功！')
				} else {
					this.$message.error('模板应用失败，请重新选择！')
				}
			})
		},
		cancel () {
			this.listPost()
		}
	}
}
</script>

<style lang="stylus" scoped>
.store-freight-body {
	display: flex
		flex-direction column
		flex: 1
		font-size 16px
		.freight-template-setting {
			display: flex
			flex: 1
			padding-top: 40px
			padding-left: 20px
			p {
				border: none
				line-height 34px
				height: 34px
				font-size: 14px
				span {
					color: #FF365F
				}
			}
	.freight-template-box {
		display flex
		flex: 1
		flex-direction column
		padding-left: 10px
			text-align: left
			.template-select {
				width: 300px
			}
			.template-item {
				padding-top 20px
				display flex
				font-size: 14px
				color: #999999
				/deep/.el-input__inner {
					text-align center
				}
				.freight-way-box {
					.freight-way {
						margin-bottom 20px
					}
				}
				span {
					display inline-block
					width: 40px
				}
				.item-name {
					width: 80px
					margin-right 10px
					color: #2c3e50
					text-align: justify
					text-align-last: justify
				}
				.template-start-input {
					width: 60px
				}
				.template-freight-input {
					width: 100px
				}
			}
		}
	}
	.freight-btn-box {
		padding: 20px 0
		text-align left
		.btn {
			width :130px;
			height :35px;
			margin-left :20px;
		}
	}
}
</style>
